import React, {PureComponent, ReactNode} from 'react';
import {Field} from 'redux-form';

import {withGenericFormFieldElements} from 'forms/components/Field/withGenericFormFieldElements';
import Textarea, {TextareaInnerProps, TextareaOuterProps} from 'forms/components/Textarea';

class TextareaField extends PureComponent<TextareaInnerProps> {
    render(): ReactNode {
        return withGenericFormFieldElements(Textarea, this.props);
    }
}

class TextareaFieldOuter extends PureComponent<TextareaOuterProps> {
    render(): ReactNode {
        const {
            name,
            label,
            className,
            disabled,
            helpText,
            onAction,
            tooltip,
            wrapperClassName,
            rows,
            onFieldBlur,
            onFieldChange,
            fieldIsLoading,
        } = this.props;

        return <Field
            component={TextareaField}
            name={name}
            rows={rows}
            label={label}
            className={className}
            disabled={disabled}
            helpText={helpText}
            onAction={onAction}
            tooltip={tooltip}
            wrapperClassName={wrapperClassName}
            onFieldChange={onFieldChange}
            onFieldBlur={onFieldBlur}
            fieldIsLoading={fieldIsLoading}
        />;
    }
}

export default TextareaFieldOuter;
